import React from 'react';
import isEqual from 'fast-deep-equal';
import { AutoComplete } from '../AutoComplete';
import ZoneFilter from '../Zones/zoneFilter';
import Pill from '../Nursery/NurseryPill';
import { cleanSearch, resetParam, getQuery } from '../../utils/helpers';
import api from '../../services/api';
import { IcnSearch, IcnSearchClear } from '../../themes/icons/attributes';
import { withNurseryContext } from '../../contexts/NurseryContext';
import { withSearchContext } from '../../contexts/SearchContext';
let abortController = null;
const computeDerivedInputValue = (props) => {
    const { searchTerm, nurseryName, nurserySlug } = props;
    const nextSearchTerm = typeof searchTerm === 'string' ? searchTerm : '';
    const matchesSlug = (nurserySlug !== null
        && nurserySlug !== undefined
        && searchTerm !== null
        && searchTerm !== undefined
        && (isEqual(nurserySlug, searchTerm)
            || (typeof nurserySlug === 'string'
                && typeof searchTerm === 'string'
                && nurserySlug.toLowerCase() === searchTerm.toLowerCase())));
    const matchesNurseryName = (nurseryName !== null
        && nurseryName !== undefined
        && searchTerm !== null
        && searchTerm !== undefined
        && (isEqual(nurseryName, searchTerm)
            || (typeof nurseryName === 'string'
                && typeof searchTerm === 'string'
                && nurseryName.toLowerCase() === searchTerm.toLowerCase())));
    if (matchesSlug || matchesNurseryName) {
        return '';
    }
    return nextSearchTerm;
};
class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
        this.submitButton = React.createRef();
        this.collapse = () => {
            this.setState({ acActive: false });
        };
        this.handleInputChange = (e) => {
            const { acActive } = this.state;
            const newValue = e.target.value;
            this.setState({ inputValue: newValue }, () => {
                if (newValue.length >= 3) {
                    clearTimeout(this.delay);
                    this.delay = setTimeout(() => {
                        this.triggerAutocomplete(newValue);
                    }, 50);
                }
                else if (acActive) {
                    if (abortController) {
                        abortController.abort();
                    }
                    this.setState({
                        acActive: false,
                        selectedIndex: -1,
                    });
                }
            });
        };
        this.triggerAutocomplete = (key) => {
            // Cancel any existing request
            if (abortController) {
                abortController.abort();
            }
            // Create new AbortController for this request
            abortController = new AbortController();
            api.search.autocomplete(key, { signal: abortController.signal })
                .then((data) => {
                this.setState({
                    acData: data,
                    acActive: data.suggestions.length > 0,
                    selectedIndex: -1,
                });
            })
                .catch(() => {
            });
        };
        this.clearSearch = (e) => {
            var _a;
            e.preventDefault();
            this.setState({
                inputValue: '',
                acActive: false,
                selectedIndex: -1,
            });
            const { setQueries, setOrigSearchTerm, isNursery, nurserySlug, } = this.props;
            setOrigSearchTerm('');
            if (setQueries) {
                const currentQuery = cleanSearch(window.location.search);
                const searchWithoutRaw = resetParam(currentQuery, 'raw', false);
                const slugForReset = isNursery ? nurserySlug : '';
                const nextQuery = searchWithoutRaw;
                setTimeout(() => {
                    setQueries(nextQuery, '', 'raw', slugForReset || '', '');
                }, 0);
            }
            if (typeof window !== 'undefined')
                (_a = document === null || document === void 0 ? void 0 : document.getElementById('search_input')) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
        };
        this.handleSubmit = (e, query, queryType) => {
            const { acData, selectedIndex } = this.state;
            const { setQueries, setOrigSearchTerm, activeZone } = this.props;
            let passQuery = query;
            let passQueryType = queryType;
            let url;
            e.preventDefault();
            if (abortController) {
                abortController.abort();
            }
            let searchString = '';
            if (selectedIndex !== -1) {
                passQuery = acData.suggestions[selectedIndex];
                passQueryType = acData.data[selectedIndex].type;
            }
            setOrigSearchTerm(passQuery);
            searchString = 'all_plants=True';
            if (passQuery)
                searchString = getQuery(passQuery, passQueryType);
            if (activeZone !== '0') {
                searchString += `&zone=${activeZone}`;
            }
            let slug = '';
            if (passQueryType === 'Nursery') {
                slug = acData.data[selectedIndex].slug;
            }
            const selectedData = acData.data[selectedIndex];
            if (selectedData) {
                if (selectedData.url) {
                    url = selectedData.url;
                }
                else if (selectedData.url === '') {
                    searchString = `raw=${acData.suggestions[selectedIndex]}`;
                }
            }
            this.setState({
                acActive: false,
                inputValue: passQuery,
                selectedIndex: -1,
            });
            setQueries(searchString, passQuery, passQueryType, slug, url);
        };
        this.clearNurserySearch = () => {
            const { setQueries, showNurseryHeader, history, setNurseryName, setNurserySlug, } = this.props;
            setNurseryName('');
            setNurserySlug('');
            if (window.location.pathname.indexOf('/plants/') === -1) {
                const rawSearchParams = new URLSearchParams(window.location.search);
                const rawQuery = (window.location.search && window.location.search.split('?')[1]) || '';
                const rawValue = rawSearchParams.get('raw') || '';
                if (window.location.pathname.indexOf('/nurseries/') !== -1) {
                    const nextPath = rawQuery ? `/search/?${rawQuery}` : '/search/';
                    history === null || history === void 0 ? void 0 : history.push(nextPath, { getAPIData: true });
                }
                else if (setQueries && rawQuery) {
                    setQueries(rawQuery, rawValue, 'raw');
                }
                else {
                    history === null || history === void 0 ? void 0 : history.push('/search/', { getAPIData: true });
                }
            }
            else {
                const path = window.location.href.split('?')[0].split('/plants/')[1];
                history === null || history === void 0 ? void 0 : history.push(`/plants/${path}`);
            }
            showNurseryHeader(false);
        };
        this.handleAutocompleteDismiss = (e) => {
            if (e.target !== this.textInput.current && e.target !== this.submitButton.current) {
                this.setState({
                    acActive: false,
                    selectedIndex: -1,
                }, () => this.handleInputKeyDown(e));
            }
        };
        this.handleInputKeyDown = (e) => {
            const { acActive, acData, selectedIndex } = this.state;
            if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && acActive) {
                e.preventDefault();
                const newState = {};
                if (e.key === 'ArrowDown') {
                    newState.selectedIndex = selectedIndex + 1;
                    if (newState.selectedIndex >= acData.suggestions.length) {
                        newState.selectedIndex = 0;
                    }
                }
                else if (e.key === 'ArrowUp') {
                    newState.selectedIndex = selectedIndex - 1;
                    if (newState.selectedIndex < 0) {
                        newState.selectedIndex = acData.suggestions.length - 1;
                    }
                }
                this.setState(newState);
            }
        };
        this.handleAutocompleteItemSelect = (selectedIndex) => {
            this.setState({
                selectedIndex,
            });
        };
        this.passWidth = (width) => {
            this.setState({
                pillWidth: `${width}px`,
            });
        };
        this.state = {
            inputValue: '',
            acActive: false,
            acData: {
                data: [
                    {
                        first: false,
                        id: 0,
                        type: '',
                        raw: '',
                        slug: '',
                        url: '',
                    },
                ],
                query: '',
                suggestions: [],
            },
            selectedIndex: -1,
            pillWidth: '0',
            lastSyncedSearchTerm: null,
            lastSyncedNurseryName: null,
            lastSyncedNurserySlug: null,
        };
        if (typeof window !== 'undefined')
            document.addEventListener('click', this.handleAutocompleteDismiss, false);
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const nextSearchTerm = typeof nextProps.searchTerm === 'string' ? nextProps.searchTerm : '';
        const nextNurseryName = typeof nextProps.nurseryName === 'string' ? nextProps.nurseryName : '';
        const nextNurserySlug = typeof nextProps.nurserySlug === 'string' ? nextProps.nurserySlug : '';
        const propsChanged = nextSearchTerm !== prevState.lastSyncedSearchTerm
            || nextNurseryName !== prevState.lastSyncedNurseryName
            || nextNurserySlug !== prevState.lastSyncedNurserySlug;
        if (!propsChanged) {
            return null;
        }
        const derivedInputValue = computeDerivedInputValue(nextProps);
        const stateUpdate = {
            lastSyncedSearchTerm: nextSearchTerm,
            lastSyncedNurseryName: nextNurseryName,
            lastSyncedNurserySlug: nextNurserySlug,
        };
        if (derivedInputValue !== prevState.inputValue) {
            stateUpdate.inputValue = derivedInputValue;
        }
        return stateUpdate;
    }
    componentDidMount() {
        const { searchTerm, setOrigSearchTerm, } = this.props;
        const derivedInputValue = computeDerivedInputValue(this.props);
        if (derivedInputValue === searchTerm && searchTerm !== '') {
            setOrigSearchTerm(searchTerm);
        }
    }
    componentDidUpdate(prevProps) {
        const { setOrigSearchTerm, searchTerm, } = this.props;
        if (searchTerm !== prevProps.searchTerm) {
            const derivedInputValue = computeDerivedInputValue(this.props);
            if (derivedInputValue === searchTerm) {
                setOrigSearchTerm(searchTerm);
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.handleAutocompleteDismiss, false);
    }
    render() {
        const { acActive, acData, selectedIndex, pillWidth, inputValue, } = this.state;
        const { zoneSetHandler, zones, activeZone, nursery, } = this.props;
        let autoCompleteEl;
        let inputClass = 'search__input';
        let wrapperClass = 'search__input-wrap';
        let pill;
        let indent;
        if (acActive) {
            autoCompleteEl = (React.createElement(AutoComplete, { acData: acData, selectedIndex: selectedIndex, handleSubmit: this.handleSubmit, handleAutocompleteItemSelect: this.handleAutocompleteItemSelect }));
            wrapperClass += ' ac__active';
        }
        if (nursery) {
            pill = (React.createElement(Pill, { clearNurserySearch: this.clearNurserySearch, nursery: nursery, passWidth: this.passWidth }));
            inputClass += ' pill_active';
            indent = {
                marginLeft: pillWidth,
            };
        }
        return (React.createElement("div", { className: "search__container" },
            React.createElement("form", { onSubmit: (e) => {
                    this.handleSubmit(e, inputValue, 'raw');
                }, className: "search__form" },
                React.createElement("div", { className: "search__count" },
                    React.createElement("a", { href: "/", className: "home_link" },
                        React.createElement("img", { className: "logo", src: "https://d17vsf20mehj1i.cloudfront.net/static/img/pl_logo_dark.svg", alt: "" }))),
                React.createElement("div", { className: "search__center" },
                    React.createElement("div", { className: wrapperClass },
                        React.createElement("input", { autoComplete: "off", spellCheck: "false", autoCapitalize: "none", autoCorrect: "off", style: indent, id: "search_input", tabIndex: 0, onBlur: this.collapse, className: inputClass, type: "text", placeholder: "Search for Plants...", value: inputValue, onChange: this.handleInputChange, onKeyDown: this.handleInputKeyDown, ref: this.textInput }),
                        React.createElement("span", { className: "search__clear", onClick: this.clearSearch, role: "button", tabIndex: -1, onKeyDown: this.clearSearch },
                            React.createElement(IcnSearchClear, { className: "icn" })),
                        React.createElement("button", { className: "search__submit", type: "submit", value: "Submit", ref: this.submitButton },
                            React.createElement(IcnSearch, { className: "icn" })),
                        pill),
                    autoCompleteEl),
                React.createElement(ZoneFilter, { activeZone: activeZone, zones: zones, zoneSetHandler: zoneSetHandler }))));
    }
}
export default withNurseryContext(withSearchContext(SearchBar));
